import { ReactNode } from "react";

interface CompletionPillProps {
  children: ReactNode;
}

export function CompletionPill({ children }: CompletionPillProps) {
  return (
    <span className="inline-flex animate-gentle-slide-in items-center gap-1.5 rounded-full bg-[#F2F2F3] px-3 py-1 text-sm font-semibold text-[#787B7E]">
      {children}
    </span>
  );
}
